import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../../assets/images/tekstas-logo.svg';
import './Footer.scss';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <Container>
        <Row className="py-5">
          <Col md={4} className="mb-4 mb-md-0">
            <Link to="/" className="footer-logo">
              <img src={logo} alt="Tekstas Logo" style={{ filter: 'brightness(0) invert(1)' }} />
            </Link>
            <p className="mt-3">{t('footer.description')}</p>
          </Col>
          <Col md={3} className="mb-4 mb-md-0">
            <h5>{t('footer.quick_links')}</h5>
            <ul className="list-unstyled">
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/exhibitions">{t('nav.exhibitions')}</Link></li>
              <li><Link to="#about">{t('footer.about')}</Link></li>
              <li><Link to="#careers">{t('footer.careers')}</Link></li>
            </ul>
          </Col>
          <Col md={3} className="mb-4 mb-md-0">
            <h5>{t('footer.contact')}</h5>
            <ul className="list-unstyled">
              <li>{t('footer.email')}</li>
              <li>{t('footer.phone')}</li>
              <li>{t('footer.address')}</li>
            </ul>
          </Col>
          <Col md={2}>
            <h5>{t('footer.follow_us')}</h5>
            <div className="social-links">
              <a href="#" className="me-3"><i className="fab fa-facebook"></i></a>
              <a href="#" className="me-3"><i className="fab fa-twitter"></i></a>
              <a href="#" className="me-3"><i className="fab fa-linkedin"></i></a>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="footer-bottom">
        <Container>
          <p className="text-center mb-0">{t('footer.copyright')}</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;